<template>
  <div>
    <app-tracking></app-tracking>
    <app-disclaimer></app-disclaimer>
    <app-header></app-header>
    <router-view></router-view>
  </div>
</template>

<script>
import Journey from "@/mixins/journey/Journey";
import Header from "@/components/journey/Header";
import Disclaimer from "@/components/journey/Disclaimer";
import Tracking from "@/components/journey/Tracking";

export default {
  name: 'community',
  mixins: [Journey],
  components: {
    'app-header': Header,
    'app-disclaimer': Disclaimer,
    'app-tracking': Tracking
  },
  data() {
    return {
      loaded: false,
      sub: null
    }
  },
  watch: {},
  created() {
    // this.$store.dispatch('fetchMasterplanConfig');
    this.$store.dispatch('fetchHomeSummary');
  },
  methods: {
  },
  mounted() {
    this.$router.afterEach((to, from) => {
      document.getElementById("header-bar").scrollIntoView();
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/journey/Community.vue